/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsCart = {
  init: function ($section) {

    // Add settings from schema to current object
    //Shopify.theme.jsCart = $.extend(this, Shopify.theme.getSectionData($section));

    this.$section = $section;

    $(document).on('click', '[data-cart-page-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).data('line-item-key');
      Shopify.theme.jsCart.removeFromCart(lineID);

      return false;
    });

    // Prevent the ajax cart form from being submitted when pressing the "Enter" key
    $('#cart_form').keydown(function(e){
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });

    // Bundle & Main Products Removal
    document.addEventListener('click', e => {
      const btn = e.target.closest('.cart__remove');
      const product = btn?.closest('.cart__card');
      const bundle = product?.dataset.bundlesItem;

      if (!bundle) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const updates = Object.fromEntries(
        [...document.querySelectorAll(`.cart__card[data-bundles-item="${bundle}"]`)]
          .map(el => [el.querySelector('[data-cart-item-key]').dataset.cartItemKey, 0])
      );

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({ updates })
      })
      .then(response => response.json())
      .then(cart => Shopify.theme.jsCart.updateView(cart));
    }, true);

    // Bundle & Main Products Qty Update
    $('body').on('click', '.quantity-plus, .quantity-minus', function(e) {
      const $product = $(this).closest('.cart__card');
      const bundle = $product.data('bundles-item');
      if (!bundle) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      let qty = parseInt($product.find('.quantity-input').val());
      if ($(this).hasClass('quantity-plus')) qty++;
      if ($(this).hasClass('quantity-minus')) qty--;
      if (qty < 1) return;

      const updates = {};
      $(`.cart__card[data-bundles-item="${bundle}"]`).each(function() {
        const key = $(this).find('.cart__remove').data('cart-item-key');
        if (key) updates[key] = qty;
      });

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      })
      .then(res => res.ok ? res.json() : Promise.reject())
      .then(cart => {
        $(`.cart__card[data-bundles-item="${bundle}"]`).each(function() {
          $(this).find('.quantity-input').val(qty).attr('data-quantity-value', qty);
        });
        Shopify.theme.jsCart.updateView(cart);
        if (typeof Shopify.theme.jsAjaxCart !== 'undefined') Shopify.theme.jsAjaxCart.updateView();
      })
      .catch(() => {});
    });


    // Donation product Qty multiply
    document.addEventListener('click', function(e) {
      const target = e.target.closest('.quantity-plus, .quantity-minus');
      if (!target) return;
      
      const $btn = $(target);
      const $product = $btn.closest('.cart__card');
      if (!$product.length) return;
      
      const donationVal = parseInt($product.attr('data-custom-donation')) || 0;
      if (donationVal < 1) return;
      
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const step = donationVal > 25 ? donationVal : 1;

      let qty = parseInt($product.find('.quantity-input').val()) || 0;
      
      if ($btn.hasClass('quantity-plus')) {
        qty += step;
      } else if ($btn.hasClass('quantity-minus')) {
        qty = Math.max(0, qty - step);
      }
      
      if (qty < 1) {
        $product.find('.cart__remove').trigger('click');
        return;
      }

      const lineKey = $product.data('line-item');
      
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: `line=${lineKey}&quantity=${qty}`
      })
      .then(res => res.ok ? res.json() : Promise.reject())
      .then(cart => {
        $product.find('.quantity-input').val(qty).attr('data-quantity-value', qty);
         Shopify.theme.jsCart.updateView(cart);
         
        if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
          Shopify.theme.jsAjaxCart.updateView();
        }
      })
      .catch(() => {});
    }, true);

  },
  removeFromCart: function (lineID) {
    const $cartItem = Shopify.theme.jsCart.$section.find(`[data-line-item="${lineID}"]`);

    $cartItem.css('opacity', '0.5');

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {

        $cartItem.addClass('animated zoomOut')
        $cartItem.remove();

        Shopify.theme.jsCart.updateView(cart, lineID);
        Shopify.theme.jsAjaxCart.updateView();

        if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
          Shopify.theme.jsAjaxCart.updateView();
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  updateView: function (cart, lineID) {

    if (cart.item_count > 0) {
      $.ajax({
        dataType: "json",
        async: false,
        cache: false,
        dataType: 'html',
        url: "/cart",
        success: function (html) {

          if (lineID !== null) {

            const updatedItems = $(html).find('.cart__item-list .cart__card');
            const currentItems = $('.cart__item-list .cart__card');

            // Checks if BOGO applied and there is a change in the number of line items
            if (updatedItems.length != currentItems.length){
              const updatedCartList = $(html).find('.cart__item-list');
              // Re-append cart items
              $('.cart__item-list').replaceWith(updatedCartList);
            }

            $(currentItems).each(function(index, element){
              $(element).attr('data-line-item', (index + 1));
              $(element).find('[data-line-item-key]').attr('data-line-item-key', (index + 1));
            })

            const itemTotal = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__total');
            const quantityInput = $(html).find(`[data-line-item="${lineID}"]`).find('.quantity-input');
            const itemPrice = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__price');

            $(`[data-line-item="${lineID}"]`).find('.cart__total').replaceWith(itemTotal);
            $(`[data-line-item="${lineID}"]`).find('.quantity-input').replaceWith(quantityInput);
            $(`[data-line-item="${lineID}"]`).find('.cart__price').replaceWith(itemPrice);

          }

          const subtotal = $(html).find('.cart__footer');

          $('.cart__footer').replaceWith(subtotal);

          $('[data-bind="itemCount"]').text(cart.item_count);

        }
      });

    } else {
      $('.cart__empty-cart-message').removeClass('is-hidden');
      $('.cart__form').addClass('is-hidden');
      $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
      $('[data-bind="itemCount"]').text('0');
    }

  },
  unload: function ($section) {
    // Clear event listeners in theme editor
    $('[data-cart-page-delete]').off();
    $('#cart_form').off();
  }
}

/******/ })()
;